import React from "react";
import axios from 'axios';
//import DynamicElementComponent from '../components/DynamicElementComponent';
import { isMobile, isTablet } from 'react-device-detect';
//***** DONT DELETE BELOW IMPORTS******Jothi**//
//import { isEmpty } from "lodash";
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@vds/modals';
import { Col, Grid, Row } from '@vds/grids';
//import VDSModal from '../components/VDSModal';
//import omnitagging from '../utilities/omnitagging';
import { postHttpClientRequest } from "../services/httpClient";
import apiUrl from "../utilities/apiUrl";
import styled from 'styled-components';
import DisneyImage from '../../assets/ak-cached/2h/images/Icon - Disneyplus.svg';
import AppleImage from '../../assets/ak-cached/2h/images/Icon - Apple Music.svg';
import DisneyBundledImage from '../../assets/ak-cached/2h/images/Hulu_DisneyPlus_ESPNPlus_LogoGrouped.svg';
import DiscoveryPlusImage from '../../assets/ak-cached/2h/images/discovery-plus-pmd.png';
import AppleArcade from '../../assets/ak-cached/2h/images/applearcade-logo-bw-pmd.png';
import GooglePass from '../../assets/ak-cached/2h/images/googleplaypass-logo-pmd.png';
import VerizonUpRewards from '../../assets/ak-cached/2h/images/verizonup_logo_-_desktop.png';

let chunkArray = null;

const common = {
  getHeaders: function (headersObj) {
    let headers = new Headers(headersObj);
    let hdrMap = new Map();

    let keys = ["osType", "mdn", "pageName", "SessionId"];
    var returnValue = {};
    try {
      if (headers != null) {
        keys.forEach(keyName => {
          if (headers.has(keyName)) {
            returnValue[keyName] = headers.get(keyName);
          }
        });
      }
    } catch (ex) { }
    return JSON.stringify(returnValue);
  },
  getApiMethodName: function (apiUrl) {
    let methodName = "";
    try {
      if (apiUrl != "") {
        let apiParams = apiUrl.split("/");
        methodName = apiParams[apiParams.length - 1];
      }
    } catch (ex) { }
    return methodName;
  },
  getErrorMessage: function (error) {
    let errorMsg = "";
    try {
      if (error != null && error.error != null) {
        if (error.status == 200 && error.error.error != null)
          errorMsg =
            error.error.error.message != null
              ? error.error.error.message
              : JSON.stringify(error.error.error);
        else errorMsg = JSON.stringify(error.error);
      } else {
        if (error.status != null) errorMsg += `STATUS=${error.status},`;
        if (error.message != null) errorMsg += `MSG=${error.message}`;
      }
      if (errorMsg == "") errorMsg = JSON.stringify(error);
    } catch (ex) {
      errorMsg = JSON.stringify(error);
    }
    return errorMsg;
  },
  getChannelId: function (sURL) {
    let channelID = "";
    if (typeof _dg_channelId !== "undefined" && _dg_channelId) {
      channelID = _dg_channelId;
    } else if (isTablet) {
      channelID = "VZW-DOTCOM-TAB";
    } else {
      channelID = "VZW-DOTCOM";
    }
    console.log("channelID: " + channelID);
    return channelID;
  },
  getClientId: function (sURL) {
    let clientId = "";
    if (typeof _dg_clientId !== "undefined" && _dg_clientId) {
      clientId = _dg_clientId;
    } 
    console.log("clientId: " + clientId);
    return clientId;
  },
  isACSS: function () {
    let isAcss = false;
    const sClientId = this.getClientId();
    if (sClientId == "VZW-ACSS") {
      isAcss = true;
    }
    console.log("isAcss: " + isAcss);
    return isAcss;
  },
  isPOS: function () {
    let isPOS = false;
    const sClientId = this.getClientId();
    if (sClientId == "VZW-NETACE") {
      isPOS = true;
    }
    return isPOS;
  },
  getOsType: function (isIOS, isAndroid) {
    var sOsType = "web";
    const sChannelId = this.getChannelId();
    if (sChannelId == "VZW-MFA") {
        if (isIOS) {
            sOsType = "ios";
        } else if (isAndroid) {
            sOsType = "android";
        }
    } else if (sChannelId == "VZW-DOTCOM-MOB") {
        if (isIOS) {
            sOsType = "mios";
        } else if (isAndroid) {
            sOsType = "mandroid";
        }
    }
    return sOsType;
},

  getDeviceType: function () {
    let deviceType = _dg_deviceType;
    console.log("deviceType: " + deviceType);
    return deviceType;
  },

  getDeviceName: function () {
    let deviceName = _dg_deviceName;
    console.log("deviceName: " + deviceName);
    return deviceName;
  },

  isApiSuccess: function (msResp) {
    let bReturn = false;
    if (
      msResp &&
      (msResp.status == 200 ||
        (msResp.status == 500 &&
          msResp.data &&
          msResp.data.body &&
          ((msResp.data.body.sections &&
            msResp.data.body.sections.length > 0) ||
            (msResp.data.body.sectionTemplates &&
              msResp.data.body.sectionTemplates.length > 0))))
    ) {
      bReturn = true;
    }
    return bReturn;
  },

  isError: function (statusCode, statusMessage, msResp) {
    let errorMsg = "";
    try {
      if (statusCode !== "00") {
        let errContent = this.getContentFromSection(msResp, "errorSection");
        errorMsg =
          errContent &&
            errContent.contents[0].items.find(c => c.itemKey === "headerText")
            ? errContent.contents[0].items.find(c => c.itemKey === "headerText")
              .itemValue
            : "";
      }
    }
    catch (ex) { }
    return errorMsg;
  },

  isErrorDesc: function (statusCode, statusMessage, msResp) {
    let errorDescription = "";
    try {
      if (statusCode !== "00") {
        let errContent = this.getContentFromSection(msResp, "errorSection");
        errorDescription =
          errContent &&
            errContent.contents[0].items.find(c => c.itemKey === "subHeaderText")
            ? errContent.contents[0].items.find(
              c => c.itemKey === "subHeaderText"
            ).itemValue
            : "";
      }
    }
    catch (ex) { }
    return errorDescription;
  },

  isActionValue: function (statusCode, statusMessage, msResp) {
    let actionVal = "";
    let actionValue = "";
    try {
      if (statusCode !== "00") {
        let errContent = this.getContentFromSection(msResp, "errorSection");
        actionVal =
          errContent &&
            errContent.contents[0].items.find(c => c.itemKey === "HomeLink")
            ? errContent.contents[0].items.find(c => c.itemKey === "HomeLink")
              .actionKey
            : "";
        actionValue =
          actionVal &&
            errContent &&
            errContent.actions.find(i => i.actionKey == actionVal)
            ? errContent.actions.find(i => i.actionKey == actionVal).actionValue
            : "";
      }
    }
    catch (ex) { }
    return actionValue;
  },

  isActionName: function (statusCode, statusMessage, msResp) {
    let actionTitle = "";
    try {
      if (statusCode !== "00") {
        let errContent = this.getContentFromSection(msResp, "errorSection");
        actionTitle =
          errContent &&
            errContent.contents[0].items.find(c => c.itemKey === "HomeLink")
            ? errContent.contents[0].items.find(c => c.itemKey === "HomeLink")
              .itemValue
            : "";
      }
    }
    catch (ex) { }
    return actionTitle;
  },

  getClickStream: function (actionKey, actions) {
    let action =
      actions && actions.find(action => action.actionKey === actionKey);
    return !action || !action.clickStream ? actionKey : action.clickStream;
  },

  updateConfirmLog: function (
    toPlanName,
    fromPlanName,
    mdn,
    toPlanCost,
    fromPlanCost
  ) {
    const classConfirmData = {
      toPlanName: "",
      fromPlanName: "",
      mdn: "",
      toPlanCost: "",
      fromPlanCost: "",
      apeligible: "false",
      apenroll: "false",
      numOfLine: "",
      isCpc: false
    };
    if (!(typeof vzwDL === "undefined" || vzwDL === null) && vzwDL) {
      if (
        typeof vzwDL.confirmLog === "undefined" ||
        vzwDL.confirmLog === null
      ) {
        vzwDL.confirmLog = [];
      }

      const omdn = vzwDL.confirmLog.find(item => item.mdn === mdn);
      if (omdn) {
        vzwDL.confirmLog.map((obj, index) => {
          if (mdn == obj.mdn) {
            vzwDL.confirmLog[index].toPlanName = toPlanName;
            vzwDL.confirmLog[index].fromPlanName = fromPlanName;
            vzwDL.confirmLog[index].toPlanCost = toPlanCost;
            vzwDL.confirmLog[index].fromPlanCost = fromPlanCost;
            vzwDL.confirmLog[index].isCpc = toPlanName !== fromPlanName;
            //confirmData[index].numOfLine = numOfLine && numOfLine != "" ? numOfLine : confirmData[index].numOfLine;
            //confirmData[index].apotp = apotp && apotp != "" ? apotp : confirmData[index].apotp;
          }
        });
      } else {
        let obj = classConfirmData;
        obj.mdn = mdn;
        obj.toPlanName = toPlanName;
        obj.fromPlanName = fromPlanName;
        obj.toPlanCost = toPlanCost;
        obj.fromPlanCost = fromPlanCost;
        obj.isCpc = toPlanName !== fromPlanName;
        // obj.numOfLine = numOfLine;
        vzwDL.confirmLog.push(obj);
      }
    }
  },

  getPlanType: function (type) {
    let planType = "UNKNOWN";
    if (
      !(typeof reactGlobals === "undefined" || reactGlobals === null) &&
      !type
    ) {
      type = reactGlobals && reactGlobals.planType ? reactGlobals.planType : "";
    }
    type = type ? type.toUpperCase() : "";
    if (
      type === "ALP" ||
      type === "TVP1" ||
      type === "TVP2" ||
      type === "TVP3" ||
      type === "TVP4"
    ) {
      planType = "account level";
    } else if (type === "LLP" || type === "ME") {
      planType = "line level";
    }
    return planType;
  },

  avoidCache: function (url) {
    if (url && url != "") {
      if (url.indexOf("?") > 0) {
        url = url + "&tv=" + new Date().getTime();
      } else {
        url = url + "?" + new Date().getTime();
      }
    }
    return url;
  },
  loadUtagScript(callback) {
    const existingScript = document.getElementById("utag");
    let tagUrl = "";
    if (
      !(typeof _vzwTagUrl === "undefined" || _vzwTagUrl === null) &&
      _vzwTagUrl
    ) {
      tagUrl = _vzwTagUrl;
    }
    if (!existingScript && tagUrl) {
      const script = document.createElement("script");
      script.src = tagUrl;
      script.id = "utag";
      document.body.appendChild(script);

      script.onload = () => {
        if (callback) callback();
      };
    }
    if (existingScript && callback) callback();
  },

  getPlanTypeFromLandingPage(landingPageData) {
    let planType = "UNKNOWN";
    if (landingPageData) {
      const mainPageSection =
        landingPageData &&
        landingPageData.sections &&
        landingPageData.sections.find(s => s.sectionType === "mainPageSection");
      const planDetailsContent =
        mainPageSection &&
        mainPageSection.sections &&
        mainPageSection.sections.find(
          s => s.sectionType === "planDetailsSection"
        );
      let currentPlanType =
        planDetailsContent &&
        planDetailsContent.contents &&
        planDetailsContent.contents.length > 0 &&
        planDetailsContent.contents[0].items &&
        planDetailsContent.contents[0].items.find(i => i.itemKey === "planType")
          .itemValue;
      currentPlanType = currentPlanType ? currentPlanType.toUpperCase() : "";

      if (
        currentPlanType === "ALP" ||
        currentPlanType === "TVP1" ||
        currentPlanType === "TVP2" ||
        currentPlanType === "TVP3" ||
        currentPlanType === "TVP4"
      ) {
        planType = "account level";
      } else if (currentPlanType === "LLP" || currentPlanType === "ME") {
        planType = "line level";
      }
    }
    return planType;
  },

  setFlowTypeForTagging(targetPlanType, currentPlanType) {
    if (
      !(
        typeof vzwDL === "undefined" ||
        vzwDL === null ||
        typeof vzwDL.page === "undefined" ||
        vzwDL.page === null
      )
    ) {
      vzwDL.page.flowType = currentPlanType + "|" + targetPlanType;
    }
  },
  isEmptyVal: (value) => {
    if (typeof value === "undefined" || value === null || (value && value.length == 0)) {
      return true;
    }
  },
  getItem: (items, itemKey) => {
    const item = items && items.find(item => item.itemKey === itemKey);
    return item;
  },
  getItemValue: (items, itemKey) => {
    const item = items && items.find(item => item.itemKey === itemKey);
    return item && item.itemValue;
  },
  linkAction: (actionValue) => {
    window.open(actionValue, '_blank');
  },
  getDataKey: (items, itemKey) => {
    const item = items && items.find(item => item.itemKey === itemKey);
    return item && item.dataKey;
  },
  getActionValue: (items, actions, itemKey) => {
    const item = items && items.find(item => item.itemKey === itemKey);
    const acKey = item && item.actionKey;
    const action =
      actions && actions.find(action => action.actionKey === acKey);
    return action && action.actionValue;
  },
  getActionType: (items, actions, itemKey) => {
    const item = items && items.find(item => item.itemKey === itemKey);
    const acKey = item && item.actionKey;
    const action = actions && actions.find(ac => ac.actionKey === acKey);
    return action && action.actionType;
  },
  getSection(sections, sectionType) {
    const section =
      sections && sections.find(sec => sec.sectionType === sectionType);
    return section;
  },
  getActionKey(items, itemKey) {
    const item = items && items.find(item => item.itemKey === itemKey);
    return item && item.actionKey;
  },
  getContent(contentArray, contentType) {
    let content = "";
    try {
      content =
        contentArray &&
        contentArray.find(data => data.contentType === contentType);
    }
    catch (ex) { }
    return content;
  },
  getContentFromSection(pageContent, sectionType) {
    let content =
      pageContent &&
      pageContent.sections !== undefined &&
      pageContent.sections.find(s => s.sectionType == sectionType);
    return content;
  },
  filterByItemKey: function (list, itemKey, select = 0) {
    let listItem = [];
    if (list && list.length > 0) {
      listItem = list.filter(list => {
        return list.itemKey === itemKey;
      });
      if (select == 0) return listItem;
      else if (listItem.length > select - 1) return listItem[select - 1];
    }
  },
  checkForObjectReference(value) {
    //console.log(`checkForObjRef: ${value}`);
    if (value) {
      if (value.indexOf('this.props.') == 0) {
        let trimValue = value.substring(11, value.length);
        let params = trimValue.match(/\(([^)]+)\)/);
        //console.log(`checkForObjRef this.props.${trimValue} params: ${params}`);
        let paramArray = [];
        if (params) {
          trimValue = trimValue.replace(params[0], '');
          let paramSplit = params[1].split(/,\s*/);
          for (var i = 0; i < paramSplit.length; i++) {
            paramArray.push(this.checkForObjectReference(paramSplit[i]));
          }
          //console.log(`checkForObjRef this.props.${trimValue} params trimValue: ${trimValue}`);
          let splitValue = trimValue.split('.');
          //console.log(`checkForObjRef this.props.${trimValue} params splitValue`, splitValue);
          if (splitValue.length > 1) {
            let refValue = this.props;
            for (var x = 0; x < splitValue.length; x++) {
              refValue = refValue[splitValue[x]];
            }
            refValue = refValue.bind.apply(refValue, [this].concat(paramArray));
            //console.log(`checkForObjRef this.props.${trimValue} params refValue:`,refValue); 
            return refValue;
          }
          else return this.props[trimValue].bind.apply(this.props[trimValue], [this].concat(paramArray));
        }
        else {
          //console.log(`checkForObjRef this.props.${trimValue} trimValue: ${trimValue}`);
          let splitValue = trimValue.split('.');
          //console.log(`checkForObjRef this.props.${trimValue} splitValue`, splitValue);
          if (splitValue.length > 1) {
            let refValue = this.props;
            for (var x = 0; x < splitValue.length; x++) {
              refValue = refValue[splitValue[x]];
            }
            //console.log(`checkForObjRef this.props.${trimValue} refValue:`,refValue); 
            return refValue;
          }
          else return this.props[trimValue];
        }
      }
      else if (value.indexOf('this.') == 0) {
        let trimValue = value.substring(5, value.length);
        let params = trimValue.match(/\(([^)]+)\)/);
        //console.log(`checkForObjRef this.${trimValue} params: ${params}`);
        let paramArray = [];
        if (params) {
          trimValue = trimValue.replace(params[0], '');
          let paramSplit = params[1].split(/,\s*/);
          for (var i = 0; i < paramSplit.length; i++) {
            paramArray.push(this.checkForObjectReference(paramSplit[i]));
          }
          //console.log(`checkForObjRef this.${trimValue} params trimValue: ${trimValue}`);
          let splitValue = trimValue.split('.');
          //console.log(`checkForObjRef this.${trimValue} params  splitValue`, splitValue);
          if (splitValue.length > 1) {
            let refValue = this[splitValue[0]];
            for (var x = 1; x < splitValue.length; x++) {
              refValue = refValue[splitValue[x]];
            }
            refValue = refValue.bind.apply(refValue, [this].concat(paramArray));
            //console.log(`checkForObjRef this.${trimValue} params refValue:`,refValue); 
            return refValue;
          }
          else return this[trimValue].bind.apply(this[trimValue], [this].concat(paramArray));
        }
        else {
          //console.log(`checkForObjRef this.${trimValue} trimValue: ${trimValue}`);
          let splitValue = trimValue.split('.');
          //console.log(`checkForObjRef this.${trimValue} splitValue`, splitValue);
          if (splitValue.length > 1) {
            let refValue = this[splitValue[0]];
            for (var x = 1; x < splitValue.length; x++) {
              refValue = refValue[splitValue[x]];
            }
            //console.log(`checkForObjRef this.${trimValue} refValue:`,refValue); 
            return refValue;
          }
          else return this[trimValue];
        }
      }
      else if (this.props[value]) {
        //console.log(`checkForObjRef this.props.${value} Value:`,this.props[value]); 
        return this.props[value];
      }
      else if (this[value]) {
        //console.log(`checkForObjRef this.${value} Value:`,this[value]); 
        return this[value];
      }
      else {
        //console.log(`checkForObjRef ${value} no value found`, value); 
        return value;
      }
    }
  },
  getOnClickInfo(sectionContentMetaData, aKey, mdn) {
    if (aKey && sectionContentMetaData) {
      let actionKey = `${aKey}`;
      const TYPES = {
        redirect: "_self",
        newtab: "_blank"
      };
      console.log("sectionContentMetaData.actions", sectionContentMetaData.actions);
      console.log("actionKey ", actionKey);
      let filteredAction = sectionContentMetaData.actions.filter(x => x.actionKey == actionKey);
      const actionType = sectionContentMetaData.actions.filter(x => x.actionKey == actionKey) && sectionContentMetaData.actions.filter(x => x.actionKey == actionKey)[0] && sectionContentMetaData.actions.filter(x => x.actionKey == actionKey)[0].actionType;
      let actionHref = "";
      if (mdn) actionHref = filteredAction && filteredAction[0] && sectionContentMetaData.actions.filter(x => x.actionKey == actionKey)[0].actionValue.replace('##mtn##', mdn);
      else actionHref = filteredAction && filteredAction[0] && sectionContentMetaData.actions.filter(x => x.actionKey == actionKey)[0].actionValue;
      const clickStream = filteredAction && filteredAction[0] && sectionContentMetaData.actions.filter(x => x.actionKey == actionKey)[0].clickStream;
      let onclick;
      switch (actionType) {
        case "function":
          onclick = () => this.checkForObjectReference(actionHref)();
          break;
        case "jsfunction":
          onclick = () => eval(actionHref);
          break;
        case "route":
          onclick = () => window.location.hash = actionHref;
          break;
        case "redirect":
          onclick = () => window.location.href = actionHref;
          break;
        default:
        case "newtab":
          onclick = () => window.open(actionHref, TYPES[actionType]);
          break;
      }
      return { "onclick": onclick, "clickStream": clickStream };
    }
    else return null;
  },
  isCoreFlow(coreFlow) {
    return coreFlow
  },
  showLinksForRole(role, restrictPlanChange) {
    let showLinks = true;
    try {
      if (restrictPlanChange)
        return false;

      if (role && role.toLowerCase() == 'account_member') {
        showLinks = false;
      }
      if (!(typeof vzwDL === "undefined" || vzwDL === null) && vzwDL &&
        !(typeof vzwDL.authentication === "undefined" || vzwDL.authentication === null) && vzwDL.authentication &&
        vzwDL.authentication.userRole && vzwDL.authentication.userRole.toLowerCase() == 'mobilesecure') {
        showLinks = false;
      }
    } catch (ex) { }
    return showLinks;
  },
  redirect(url, routeType) {
    if (routeType == 'http') {
      window.location.href = url
    }
    else
      window.location.hash = url
  },
  testMigration() {
    return !(typeof testMigrateFlow === 'undefined' || testMigrateFlow === null) && testMigrateFlow;
  },
  setVzwDLVaribale(vzwDL, pgAttributes) {
    try {
      const currentMtnPlanId = pgAttributes && pgAttributes.find(i => i.itemKey == "currentMtnPlanId") &&
        pgAttributes.find(i => i.itemKey == "currentMtnPlanId").itemValue;

      if (
        !(typeof vzwDL === "undefined" || vzwDL === null) &&
        vzwDL &&
        !(typeof vzwDL.page === "undefined" || vzwDL.page === null) &&
        pgAttributes
      ) {
        vzwDL.page["area"] =
          pgAttributes.find(i => i.itemKey == "customerState") &&
          pgAttributes.find(i => i.itemKey == "customerState")
            .itemValue;
        vzwDL.page["state"] =
          pgAttributes.find(i => i.itemKey == "customerState") &&
          pgAttributes.find(i => i.itemKey == "customerState")
            .itemValue;
        vzwDL.page["zipCode"] =
          pgAttributes.find(i => i.itemKey == "customerZipCode") &&
          pgAttributes.find(i => i.itemKey == "customerZipCode")
            .itemValue;
      }
      if (
        !(typeof vzwDL === "undefined" || vzwDL === null) &&
        vzwDL &&
        !(
          typeof vzwDL.authentication === "undefined" ||
          vzwDL.authentication === null
        ) &&
        pgAttributes
      ) {
        vzwDL.authentication["visHashedAccountNumber"] =
          pgAttributes.find(
            i => i.itemKey == "hashedAccountNumber"
          ) &&
          pgAttributes.find(i => i.itemKey == "hashedAccountNumber")
            .itemValue;
        vzwDL.authentication["visHashedMdn"] =
          pgAttributes.find(i => i.itemKey == "hashedMdn") &&
          pgAttributes.find(i => i.itemKey == "hashedMdn").itemValue;
      }
      if (!(typeof vzwDL === "undefined" || vzwDL === null) && vzwDL &&
        !(typeof vzwDL.page === "undefined" || vzwDL.page === null) &&
        pgAttributes && currentMtnPlanId) {
        vzwDL.page['currentUserPlanId'] = currentMtnPlanId;
      }

      //Set VZDL variabel
      //omnitagging.setVzDLVaribale(pgAttributes);
    } catch (ex) { }
  },
  isSafetyModeV2(role) {
    let status = this.showLinksForRole(role)
    return status; //!(typeof isSafetyModeV2 == "undefined") && isSafetyModeV2;
  },
  isSpanish() {
    let retValue =
      window.location.host.toLowerCase().indexOf("espanol.verizon.com") > -1 ||
        window.location.host.toLowerCase().indexOf("es.verizon.com") > -1 ||
        window.location.host.toLowerCase().indexOf("espanol.verizonwireless.com") > -1 ||
        window.location.host.toLowerCase().indexOf("es.verizonwireless.com") > -1
        ? true : false;
    return retValue;
  },
  getDataTrackValue(type, name, currentState) {
    return JSON.stringify({ type: type, name: name, state: !currentState })
  },
  getChunkFilename() {
    axios.get(`${staticFilePath}root.js`).then((response) => {
        try {
            let respData = (response.data);

            var jsonStr = respData.replace(/(\w+:)|(\w+ :)/g, function (matchedStr) {
                return `"${matchedStr.substring(0, matchedStr.length - 1)}":`;
            });
            let result1 = jsonStr.substring(jsonStr.indexOf('{"0":"'), jsonStr.indexOf('[e]||e)+"."+{"0":"'));
            let result2 = jsonStr.substring(jsonStr.indexOf('"}[e]||e)+"."+{"0":"') + '"}[e]||e)+"."+'.length, jsonStr.indexOf('[e]+".chunk.js"'));
            let Data = JSON.parse(result2);
            console.log(Data);
            let chunkArray2 = Data;
            let chunkArray1 = JSON.parse(result1);
            chunkArray = [];
            Object.keys(chunkArray1).forEach((key) => {
                let fName = `${chunkArray1[key]}.${chunkArray2[key]}.chunk.js`;
                chunkArray.push(fName);
            });
            console.log(chunkArray);
            /*  Object.keys(Data).forEach((key) => {
               let fName = key + '.'+ Data[key]+ ".chunk.js";          
               this.loadScriptJs(staticFilePath+fName);
             }); */
        } catch (e) {
        }

    }).catch((error) => {

    });
},
  loadChunkFile(index) {
        /* if(chunkArray && chunkArray[index]){     
         let fName = index + '.'+ chunkArray1[index] + '.'+ chunkArray[index] + ".chunk.js";
         this.loadScriptJs(staticFilePath+fName);
        } */
        if (chunkArray && index) {
            let fName = chunkArray.filter(k => k.indexOf(index) == 0);
            if (fName && fName.length == 1)
                this.loadScriptJs(staticFilePath + fName[0]);
        }
  },
  isUnAuth(url) {
    return window.location.pathname.indexOf("/nos/") > -1 ; 
  }
};

export default common;